import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConsumeService } from './consume.service';
import { HttpParams } from '@angular/common/http';
import { IRiskCatalogResponse } from '../pages/buro/interfaces/riesgos.response.model.';
import { ICliente } from '../pages/buro/interfaces/history-user.model';
import { IPinRequest } from '../pages/buro/interfaces/pin.model';
import { map } from 'rxjs/operators';
import { IResponseOportunidad } from '../pages/buro/interfaces/IResponse';
import { Endpoints } from 'src/environments/endpoints';
import { sendBodyModifiedBy, sendQueryModifiedBy } from '../utils/user.interceptor';

@Injectable({
  providedIn: 'root',
})
export class BuroService {
  constructor(private consume: ConsumeService) { }

  getCatalogs(
    vCodeSet1: string,
    vCodeSet2: string
  ): Observable<IRiskCatalogResponse[]> {
    let params = new HttpParams();
    params = params.append('vCodeSet1', vCodeSet1);
    params = params.append('vCodeSet2', vCodeSet2);

    const url = `${Endpoints.buro.base}/catalogs?${params.toString()}`;
    return this.consume.httpGet(url).pipe(
      map((resp: any) => resp.data.data)
    );
  }

  getStateUser(email: string) {
    return this.consume
      .httpGet<IResponseOportunidad>(`${Endpoints.buro.base}/client/${email}`).pipe(
        map((resp) => resp)
      );
  }

  getUserByIdKey(idKey: string) {
    return this.consume
      .httpGet<IResponseOportunidad>(`${Endpoints.buro.base}/client/${idKey}`).pipe(
        map((resp) => resp)
      );
  }

  getValidBerau(idKey: string) {
    return this.consume
      .httpGet<IResponseOportunidad>(`${Endpoints.buro.base}/evaluate-boreau/?idKeycloak=${idKey}`).pipe(
        map((resp) => resp),
      );
  }

  createUser(user: ICliente) {
    return this.consume
      .httpPost<IResponseOportunidad>(`${Endpoints.buro.base}/client`, user, null, sendBodyModifiedBy()).pipe(
        map((resp) => resp),
      );
  }

  requestNIP_or_Validate(pinRequestBody: IPinRequest, idKey: string) {
    let params = `idKeycloak=${encodeURIComponent(idKey)}&metodoenvio=${pinRequestBody.metodoenvio
      }&nip=${encodeURIComponent(pinRequestBody.pin!)}`;
    return this.consume.httpGet<IResponseOportunidad>(`${Endpoints.buro.base}/nip?${params}`, null, null, sendQueryModifiedBy()).pipe(
      map((resp) => resp),
    );
  }

  requestBureau(idKey: string) {
    return this.consume.httpGet<IResponseOportunidad>(`${Endpoints.buro.base}/evaluate/${idKey}`, null, null, sendQueryModifiedBy()).pipe(
      map((resp) => resp),
    );
  }

  createUserBound(user: ICliente, idKey: string) {
    return this.consume.httpPost<IResponseOportunidad>(`${Endpoints.buro.base}/client/${idKey}`, user).pipe(
      map((resp) => resp)
    );
  }

  requestNIP_or_ValidateBound(pinRequestBody: IPinRequest, idKey: string) {
    let params = `idKeycloak=${encodeURIComponent(idKey)}&metodoenvio=${pinRequestBody.metodoenvio
      }&nip=${encodeURIComponent(pinRequestBody.pin!)}`;

    return this.consume.httpGet<IResponseOportunidad>(`${Endpoints.buro.base}/nip-endorsement?${params}`).pipe(
      map((resp) => resp),
    );
  }

  requestBureauBound(idKey: string) {

    return this.consume.httpGet<IResponseOportunidad>(`${Endpoints.buro.base}/evaluate-endorsement/${idKey}`, null, null, sendQueryModifiedBy()).pipe(
      map((resp) => resp)
    );
  }

  createNewOpportunity(idKey: string) {
    return this.consume
      .httpPost<IResponseOportunidad>(
        `${Endpoints.buro.base}/create-new-opportunity/${idKey}`,
        {}
      )
      .pipe(
        map((resp) => resp),
      );
  }

  getDocumentsTemplates(templateId: number) {
    return this.consume.httpGet<any>(`${Endpoints.buro.documentManagmentUrl}/templates/${templateId}`).pipe(
      map((resp) => resp.data)
    );
  }

  getFolderDocuments(clientid: any, templateId: any) {
    return this.consume.httpGet<any>(`${Endpoints.buro.documentManagmentUrl}/folderdocuments?clientid=${clientid}&templateId=${templateId}`).pipe(
      map((resp) => resp.data)
    );
  }

  getFolderDocumentsWithOutVaildity(clientid: any, templateId: any) {
    return this.consume.httpGet<any>(`${Endpoints.buro.documentManagmentUrl}/folderdocuments?clientid=${clientid}&templateId=${templateId}&checkValidity=0`).pipe(
      map((resp) => resp.data)
    );
  }

  uploadDocuments(data: FormData) {
    return this.consume.httpPost<any>(`${Endpoints.buro.documentManagmentUrl}/uploaddocuments`, data).pipe(
      map((resp) => resp.data)
    );
  }

  uploadFile(data: any) {
    return this.consume.httpPost<any>(`${Endpoints.buro.documentManagmentUrl}/upload-file`, data).pipe(
      map((resp) => resp.data)
    );
  }

  deleteDocuments(folderId: any, fileId: any) {
    return this.consume.httpDelete<any>(`${Endpoints.buro.documentManagmentUrl}/file?folderid=${folderId}&fileid=${fileId}`).pipe(
      map((resp) => resp)
    );
  }

  closeFolder(clientId: any) {
    return this.consume.httpPost<any>(`${Endpoints.buro.documentManagmentUrl}/closefolder?clientid=${clientId}`, {}, null, sendQueryModifiedBy()).pipe(
      map((resp) => resp)
    );
  }

  generateOpt(data: any) {
    return this.consume.httpPost<any>(`${Endpoints.buro.otp}/generate`, data).pipe(
      map((resp) => resp.data)
    );
  }

  validityDocs(clientId: any) {
    return this.consume.httpGet<any>(`${Endpoints.buro.documentManagmentUrl}/validity?clientid=${clientId}`).pipe(
      map((resp) => resp.data),
    );
  }

  mobileUploadDocuments(data: FormData) {
    return this.consume.httpPost<any>(`${Endpoints.buro.documentManagmentUrlPublic}/uploadmobile`, data).pipe(
      map((resp) => resp)
    );
  }
  validitySolicitud(clientId: any, stepCheck: any) {
    console.log('validitySolicitud', clientId, stepCheck);
    return this.consume.httpPost<any>(`${Endpoints.solicitud.validity}/:${clientId}`, stepCheck).pipe(
      map((resp) => resp.data)
    );
  }

  callStage1(rfc: string, opportunityId: number) {
    const body = { rfc, opportunityId, stage: 1 };
    return this.consume.httpPost(`${Endpoints.buro.base}/call-stage`, body);
  }

  selectMethodSign(id: string) {
    return this.consume.httpPost(
      `${Endpoints.creditV2.base}/selectMethodSign/:${id}`,
      {}
    );
  }

  signatureAutograph(idKeycloak?: string) {
    return this.consume.httpGet<any>(`${Endpoints.creditV2.base}/contract/signature-autograph/${idKeycloak}`).pipe(
      map((resp: any) => resp.data)
    );
  }

  signatureAutographDomiciliacion(idKeycloak?: string) {
    return this.consume.httpGet<any>(`${Endpoints.creditV2.base}/contract/signature-autograph-domiciliacion/${idKeycloak}`).pipe(
      map((resp: any) => resp.data)
    );
  }

  sendEmailIdentityVerification(idKeycloak: string, url: string) {
    const body = { idKeycloak, url };
    //TODO: Change the endpoint to the correct one
    return this.consume.httpPost<any>(`${Endpoints.buro.documentManagmentUrl}/ENDPOINT_NAME`, body).pipe(
      map((resp) => resp.data)
    );
  }

}
